import styled from "@emotion/styled";
import React from "react";

const Loader = () => {
  const LoaderImg = styled.img`
    position: absolute;
    right: 0.75rem;
    top:50%;
    transform:translateY(-50%);
  `;
  return <LoaderImg src="/icons/loader.svg" alt="Loader" />;
};

export default Loader;
